// @file backendState from window object
import window from '@@/bits/global'

interface BackendState {
  title?: string
  filter?: string
  is_recently_verified?: boolean
  is_student_restricted_from_deleting_account?: boolean
  is_student_in_educational_library?: boolean
  referrals_count?: number
  data?: {
    verify_user?: {
      error?: unknown
    }
  }
}

function getBackendState(): BackendState {
  return (window.$backendState || window.ww?.vueStartingState?.backendState || {}) as BackendState
}

const backendState: BackendState = getBackendState()

export type { BackendState }
export { getBackendState }
export default backendState
